'use client';

import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { track } from '@/lib/analytics/ym';

export function StickyMobileCTA() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 p-3 backdrop-blur md:hidden">
      <Link
        href="#lead"
        onClick={() => track.ctaClick('sticky_mobile')}
        className={buttonVariants({ className: 'w-full' })}
      >
        Запросить мини-аудит
      </Link>
    </div>
  );
}
